import {
    CREATE_AGENT_LICENSE,
    CREATE_AGENCY_LICENSE,
    CREATE_AGENCY_LICENSE_FAILED,
    CREATE_AGENT_LICENSE_FAILED,
    LicenseStore,
    CREATE_AGENCY_LICENSE_START,
    CREATE_AGENT_LICENSE_START,
    LicenseResponse,
    GET_AGENCY_LICENSE_START,
    GET_AGENT_LICENSE_FAILED,
    GET_AGENT_LICENSE_START,
    GET_AGENCY_LICENSE,
    GET_AGENCY_LICENSE_FAILED,
    GET_AGENT_LICENSE,
    UPDATE_AGENCY_LICENSE_START,
    UPDATE_AGENT_LICENSE_START,
    UPDATE_AGENCY_LICENSE,
    UPDATE_AGENT_LICENSE,
    UPDATE_AGENT_LICENSE_FAILED,
    UPDATE_AGENCY_LICENSE_FAILED
} from './types';

const initialState = {
    data: null,
    error: null,
    isLoading: false
  };

export const licenseInfo = (
    state: LicenseStore = {
        error: null,
        data: null,
        isLoading: false
    },
    action: {
        type: string;
        payload?: unknown;
    }
): LicenseStore => {
    switch (action.type) {
        case CREATE_AGENCY_LICENSE_START:
        case CREATE_AGENT_LICENSE_START:
        case GET_AGENCY_LICENSE_START:
        case GET_AGENT_LICENSE_START:
        case UPDATE_AGENCY_LICENSE_START:
        case UPDATE_AGENT_LICENSE_START:
            return {
                ...state,
                isLoading: true
            };
        case CREATE_AGENT_LICENSE:
        case CREATE_AGENCY_LICENSE:
        case GET_AGENT_LICENSE:
        case GET_AGENCY_LICENSE:
        case UPDATE_AGENCY_LICENSE:
        case UPDATE_AGENT_LICENSE:
            return {
                ...state,
                isLoading: false,
                error: null,
                data: action.payload as LicenseResponse
            };
        case CREATE_AGENT_LICENSE_FAILED:
        case CREATE_AGENCY_LICENSE_FAILED:
        case GET_AGENT_LICENSE_FAILED:
        case GET_AGENCY_LICENSE_FAILED:
            return {
                ...state,
                isLoading: false,
                data: null,
                error: action.payload
            };
        case UPDATE_AGENCY_LICENSE_FAILED:
        case UPDATE_AGENT_LICENSE_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        default:
            return state;
    }
};
